import { render, staticRenderFns } from "./Taxi.vue?vue&type=template&id=38938994&scoped=true&"
import script from "./Taxi.vue?vue&type=script&lang=js&"
export * from "./Taxi.vue?vue&type=script&lang=js&"
import style0 from "./Taxi.vue?vue&type=style&index=0&id=38938994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38938994",
  null
  
)

export default component.exports